<div class="error-page">
  <div class="error-card">
    <div class="error-code" *ngIf="code">{{ code }}</div>
    <h1 class="error-title">{{ title }}</h1>
    <p class="error-message">{{ message }}</p>

    <div class="actions">
      <button type="button" class="btn btn-primary" (click)="goHome()">Volver al inicio</button>
      <button *ngIf="showRetry" type="button" class="btn btn-outline-secondary" (click)="onRetry()">Reintentar</button>
    </div>
  </div>
</div>
